/* tslint:disable */
import { Formik, FormikActions, FormikProps } from 'formik';
import { Log } from 'ng2-logger';
import { IAppState, IAction } from '../../../models/action/core';
import React, { Component, Dispatch } from 'react';
import { connect } from 'react-redux';
import { Table } from 'reactstrap';
import Paginate from '../../../components/table/paginate';
import Loading from '../../loading/loading';
import SortedColumn from '../../../components/table/sorted-column';
import Moment from 'moment';
import Announce from '../../../components/templates/announce';
import * as Actions from '../../../store/actions/coursePage';
import {
    FileInitialValues,
    FilterInitialValues,
    IFileListPageProps,
    IFileListPageState,
    IFileView
} from '../../../models/components/course-files';
import * as Icons from 'react-icons/md';
import { IPagedQuery } from '../../../models/components/paginate';
import { Common } from '../../../core/common';
import Translator from '../../../core/i18n';
import DisplayFileIcon from './file-icons';
import { UploadRelationType } from '../../../models/enums/UploadRelationType';
import { UserType } from '../../../models/enums/userType';
import ContentLoader from 'react-content-loader';
const T = Translator.create();

const _common = new Common();

const _logger = Log.create('StudentAddModal');

class CourseFiles extends Component<IFileListPageProps, IFileListPageState> {
    public state: IFileListPageState = {
        filters: Object.assign({}, FilterInitialValues),
        history: [],
        showNewDirModal: false,
        model: Object.assign({}, FileInitialValues),
        selectedUploadRelationType: 0,
        selectedUploadName: 'all',
        isSearchBoxOpen: false,
        isSearchBoxShow: false
    };

    public componentDidMount() {
        this.getCourseFiles();
    }

    public componentDidUpdate(prevProps: IFileListPageProps) {
        if (prevProps.coursePageClassId !== this.props.coursePageClassId) {
            this.getCourseFiles();
        }
    }

    public getCourseFiles = () => {
        this.props.dispatch(
            Actions.getCourseFiles(
                this.props.coursePageClassId!,
                this.state.selectedUploadRelationType,
                this.props.coursePageActivityId!,
                this.state.filters,
                false,
                'getCourseFiles',
                'get'
            )
        );
    };

    public sort = (sortKey: string, orderBy: string) => {
        this.state.filters.orderBy = sortKey + '_' + orderBy;
        this.setState(this.state);
        this.getCourseFiles();
    };

    public onPageChange = (page: number) => {
        this.state.filters.page = page;
        this.setState(this.state);
        this.getCourseFiles();
    };

    public onFilterStudent(model: IPagedQuery, FormActions: FormikActions<IPagedQuery>) {
        this.state.filters = model;
        this.state.filters.page = 1;
        this.setState(this.state);
        this.getCourseFiles();
        FormActions.setSubmitting(false);
    }

    onCheckAndOpenFile = (e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>) => {
        if (e && e.currentTarget) {
            if (e.currentTarget.dataset.path) {
                let link: string = e.currentTarget.dataset.path;
                window.open(link, '_blank');
            }
        }
    };

    getEnumString = (type: any, enums: any) => {
        let localization = 'r_gen_upload_relation_type_';
        Object.keys(enums).forEach(key => {
            if (Number(key) === type) {
                localization = localization + enums[key];
            }
        });

        return localization.toLowerCase();
    };

    selectUploadRelationType = (uploadRelationType: number, uploadName: string) => {
        this.setState(
            {
                selectedUploadRelationType: uploadRelationType,
                selectedUploadName: uploadName
            },
            this.getCourseFiles
        );
    };

    triggerSearchBox = () => {
        this.setState({
            isSearchBoxOpen: !this.state.isSearchBoxOpen,
            isSearchBoxShow: true
        });
    };

    searchOnChange = (event: React.ChangeEvent<HTMLInputElement>) =>
        this.setState({ filters: { ...this.state.filters, query: event.target.value } });

    searchOnKeyUp = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (this.state.filters.query && this.state.filters.query.length && event.keyCode === 13) {
            this.getCourseFiles();
        }
    };

    searchOnClear = () => {
        this.setState({ filters: { ...this.state.filters, query: '' } }, this.getCourseFiles);
    };

    public clickToDownload = (e: any) => {
        const filepath = e.currentTarget!.getAttribute('data-filepath').toString();
        const fileName = e.currentTarget!.getAttribute('data-filename').toString();
        if (filepath && fileName) {
            _common.DownloadLink(filepath + '/download', fileName);
        }
    };

    // tslint:disable-next-line

    public render() {
        const files = this.props.results && this.props.results.length ? this.props.results : [];

        const Tablea = (
            <div className="page-container student-page">
                <div className="page-content">
                    <div className="container">
                        <div className="row student-course-header question-filter mt-5 position-relative" style={{zIndex:0}}>
                            <div className="col-md-6 text-md-left">
                                <div id="assignment-search" className={'search collapse show'} style={{ width: 250, top: -10 }}>
                                    <div className="input-group">
                                        <i
                                            className="material-icons mr-"
                                            style={{ cursor: 'pointer' }}
                                            onClick={this.getCourseFiles}
                                            id="search-icon"
                                        >
                                            search
                                        </i>
                                        <i
                                            className="material-icons mr-4"
                                            style={{ cursor: 'pointer'}}
                                            onClick={this.searchOnClear}
                                            id="clear-icon"
                                        >
                                            clear
                                        </i>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="inlineFormInputGroup"
                                            placeholder={T.t('r_gen_search')}
                                            value={this.state.filters.query ? this.state.filters.query : ''}
                                            onChange={this.searchOnChange}
                                            onKeyUp={this.searchOnKeyUp}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-6 text-md-right">
                                <div className="align-self-center p-0">
                                    <div className="options d-inline-flex align-items-center">
                                        {this.props.userType === UserType.Student ? (
                                            <div className="dropdown lead-dropdown">
                                                <a data-toggle="dropdown" aria-expanded="false">
                                                    <a>{T.t('r_fileUpload_filter')}:</a>
                                                    <label className="filter-value">
                                                        {T.t('r_gen_upload_relation_type_' + this.state.selectedUploadName)}
                                                    </label>
                                                </a>
                                                <div
                                                    className="dropdown-menu"
                                                    aria-labelledby="dropdownMenuButton"
                                                    x-placement="bottom-start"
                                                    style={{
                                                        position: 'absolute',
                                                        willChange: 'transform',
                                                        top: '0px',
                                                        left: '0px',
                                                        transform: 'translate3d(0px, 24px, 0px)'
                                                    }}
                                                >
                                                    <a
                                                        className="dropdown-item"
                                                        onClick={this.selectUploadRelationType.bind(
                                                            this,
                                                            UploadRelationType.Activity,
                                                            'activity'
                                                        )}
                                                    >
                                                        {T.t('r_gen_upload_relation_type_activity')}
                                                    </a>
                                                    <a
                                                        className="dropdown-item"
                                                        onClick={this.selectUploadRelationType.bind(
                                                            this,
                                                            UploadRelationType.Assignment,
                                                            'assignment'
                                                        )}
                                                    >
                                                        {T.t('r_gen_upload_relation_type_assignment')}
                                                    </a>
                                                    <div className="dropdown-divider" />
                                                    <a
                                                        className="dropdown-item"
                                                        onClick={this.selectUploadRelationType.bind(this, 0, 'all')}
                                                    >
                                                        {T.t('r_activity_type_All')}
                                                    </a>
                                                </div>
                                            </div>
                                        ) : (
                                            ''
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Loading spinnerId={'getCourseFiles'}>
                            <div>
                                <ContentLoader speed={2} backgroundColor="#f3f3f3" foregroundColor="#ecebeb" viewBox="0 0 700 300">
                                    <circle cx="10" cy="25" r="5" />
                                    <rect x="25" y="20" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="50" r="5" />
                                    <rect x="25" y="45" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="75" r="5" />
                                    <rect x="25" y="70" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="100" r="5" />
                                    <rect x="25" y="95" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="125" r="5" />
                                    <rect x="25" y="120" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="150" r="5" />
                                    <rect x="25" y="145" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="175" r="5" />
                                    <rect x="25" y="170" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="200" r="5" />
                                    <rect x="25" y="195" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="225" r="5" />
                                    <rect x="25" y="220" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="250" r="5" />
                                    <rect x="25" y="245" rx="5" ry="5" width="650" height="6" />
                                    <circle cx="10" cy="275" r="5" />
                                    <rect x="25" y="270" rx="5" ry="5" width="650" height="6" />
                                </ContentLoader>
                            </div>
                        </Loading>
                        <div className="page-table p-0 m-t-0" id="getCourseFiles_Content">
                            {files && files.length ? (
                                <Table
                                    className="table-user-list table-ellipsis table-mobile"
                                    striped={true}
                                    hover={true}
                                    borderless={true}
                                >
                                    <thead>
                                        <tr style={{ backgroundColor: '#eaeaea' }}>
                                            <SortedColumn
                                                datacell="name"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_file_name')}
                                                sortkey="FileName"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="activity"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_activity')}
                                                sortkey="Activity"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            {
                                                this.props.isWeekly ?
                                                 <SortedColumn
                                                datacell="week"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_course_page_week')}
                                                sortkey="Week"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            /> : null
                                            }
                                           
                                            <SortedColumn
                                                datacell="createdDate"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_upload_time')}
                                                sortkey="CreatedDate"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="fullName"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_activity_file_owner')}
                                                sortkey="FullName"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="size"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_video_file_size')}
                                                sortkey="Size"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                            <SortedColumn
                                                datacell="uploadRelationType"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_gen_upload_relation_type')}
                                                sortkey="UploadRelationType"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            />
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {files.map((item: IFileView) => {
                                            const icon: any = DisplayFileIcon(item) || <Icons.MdInsertDriveFile size="22" />;
                                            return (
                                                <tr key={'course-file-' + item.fileId} data-title={item.fileName + '-' + item.fileName}>
                                                    <td data-label={T.t('r_file_name')} scope="row">
                                                        {icon}&nbsp;
                                                        <a
                                                            style={{ color: 'inherit' }}
                                                            href="javascript:;"
                                                            data-id={item.fileId}
                                                            data-path={item.filePath}
                                                            onClick={this.clickToDownload}
                                                            data-filepath={item && item.filePath}
                                                            data-filename={item && item.fileName}
                                                        >
                                                            {item.fileName}
                                                        </a>
                                                    </td>
                                                    <td data-label={T.t('r_activity')} className="text-center">
                                                        {item.activityName}
                                                    </td>
                                                    {
                                                        this.props.isWeekly ? <td data-label={T.t('r_course_page_week')} className="text-center">
                                                        {item.week
                                                            ? T.t('r_gen_week_count').replace('{0}', item.week)
                                                            : T.t('r_gen_week_count').replace('{0}', '0')}
                                                    </td> : null
                                                    }
                                                    
                                                    <td data-label={T.t('r_upload_time')} className="text-center">
                                                        {item.createdDate
                                                            ? Moment(item.createdDate).format(
                                                                  _common.GetDateFormatFromPrefrences(this.props.userPreferences!, 1) +
                                                                      ' HH:mm'
                                                              )
                                                            : T.t('r_gen_unspecified')}
                                                    </td>
                                                    <td data-label={T.t('r_activity_file_owner')} className="text-center">
                                                        {item.fullName == null ? '-' : item.fullName}
                                                    </td>
                                                    <td data-label={T.t('r_video_file_size')} className="text-center">
                                                        {_common.BytesToSize(item.size)}
                                                    </td>
                                                    <td data-label={T.t('r_gen_upload_relation_type')} className="text-center">
                                                        {T.t(this.getEnumString(item.uploadRelationType, UploadRelationType))}
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            ) : (
                                <>
                                    <Table
                                        className="table-user-list table-ellipsis table-mobile"
                                        striped={true}
                                        hover={true}
                                        borderless={true}
                                    >
                                        <thead>
                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                <SortedColumn
                                                    datacell="name"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_file_name')}
                                                    sortkey="FileName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="activity"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_activity')}
                                                    sortkey="Activity"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                            {
                                                this.props.isWeekly ?
                                                <SortedColumn
                                                datacell="week"
                                                className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                title={T.t('r_course_page_week')}
                                                sortkey="Week"
                                                sortedcolumn={this.state.filters.orderBy}
                                                sort={this.sort}
                                            /> : null
                                            }
                                               
                                                <SortedColumn
                                                    datacell="createdDate"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_upload_time')}
                                                    sortkey="CreatedDate"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="fullName"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_activity_file_owner')}
                                                    sortkey="FullName"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="size"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_video_file_size')}
                                                    sortkey="Size"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                                <SortedColumn
                                                    datacell="uploadRelationType"
                                                    className="d-none d-lg-table-cell d-xl-table-cell text-center"
                                                    title={T.t('r_gen_upload_relation_type')}
                                                    sortkey="UploadRelationType"
                                                    sortedcolumn={this.state.filters.orderBy}
                                                    sort={this.sort}
                                                />
                                            </tr>
                                        </thead>
                                    </Table>
                                    <a className='lessons-text-not-found'>{T.t('r_file_not_found')}</a>
                                </>
                            )}
                            <div className="row-options justify-content-end">
                                <div
                                    className="page-sorting d-flex align-items-center justify-content-center"
                                    style={{ marginTop: '5px' }}
                                />
                                {this.props.results && this.props.results.length > 0 && (
                                    <Paginate filters={this.props.filters} onPageChange={this.onPageChange} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        return Tablea;
    }
}

const mapStateToProps = (state: IAppState, ownProps: IFileListPageProps): IFileListPageProps => {
    if (!state) {
        return ownProps;
    }
    const newProps: IFileListPageProps = Object.assign({}, ownProps, {
        results: state.coursePage.courseFiles ? state.coursePage.courseFiles.results : [],
        filters: state.coursePage.courseFiles ? state.coursePage.courseFiles.filters : [],
        coursePageClassId: state.coursePage.coursePageClassId,
        userPreferences: state.profile.userPreferences.preferences,
        userType: state.login.identitiy.userType,
        coursePageActivityId: state.coursePage.coursePageActivityId,
        isWeekly: state.coursePage.coursePageclassInformation ? state.coursePage.coursePageclassInformation.isWeekly : false,
    });
    return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
    return (
        next.coursePage.courseFiles === prev.coursePage.courseFiles &&
        next.coursePage.coursePageClassId === prev.coursePage.coursePageClassId &&
        next.coursePage.coursePageActivityId === prev.coursePage.coursePageActivityId
    );
};

const dispatchProps = (dispatch: Dispatch<IAction>) => {
    return {
        dispatch
    };
};

const container = connect(mapStateToProps, dispatchProps, null, {
    areStatesEqual
})(CourseFiles);

export default container;
